/**
 * AI 生文- 新会话
 * @returns
 */

 import {
  Box,
  Flex,
  Center,
  useDisclosure,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import { useLocation, useSearchParams } from "react-router-dom";

import { useState } from "react";
import ChatTextInput from "@/components/writingComponent/InputComponent3";
import AiSessionItem2 from "@/components/writingComponent/aiSessionItem2";
import HumanSessionItem2 from "@/components/writingComponent/humanSessionItem2";
import { useAppSelector } from "@/store/hooks";
import { selectCurrentChatList } from "@/reducer/chatSlice";
import { ChatContent } from "@/types/writing";

const AiSearch = () => {
  const user = useSelector(selectUser);
  let [searchParams, setSearchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const currentChatList = useAppSelector(selectCurrentChatList);
  // const location = useLocation();
  // 获取传递的参数
  // const passedParam = location.state && location.state.sessionId;
  // const [files, setFiles] = useState<File[]>([]);
  const [text, setText] = useState("");

  // const updateFile = (files: File[]) => {
  //   setFiles(files);
  // };
  const updataInputValue = (chatMsg:ChatContent) => {
    // setText(text);
  };
  const updateValue = (text:string) => {
    setText(text);
  };
  const handleSubmit = () => {
    console.log(text, "text2>>>>");
  };


  return (
    <>
      <Flex flexDirection="column" h="100%" maxW={"1028px"} m="0 auto">
        <Box flex={1} h="0" mt="50px" mb="50px">
          <Box h="100%" overflow={"auto"}>
            {currentChatList && currentChatList.map((item, index) => {
              return (
                <Box key={index}>
                  {(item.message_role === "assistant" || item.message_role === "system") && <AiSessionItem2 sessionContent={item} reAnswer={updataInputValue} />}
                  {item.message_role === "user" && (
                    <HumanSessionItem2 sessionContent={item} />
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box ml="54px" mb="40px">
          <ChatTextInput
            text={text}
            updateValue={updateValue}
            handleSubmit={handleSubmit}
          />
        </Box>
      </Flex>
    </>
  );
}

export default AiSearch;